export default "__VITE_ASSET__Dk6NHhqL__"